import Swiper, { Autoplay, Navigation } from 'swiper';
import { swiperObserver } from '../utils/swiper.utils.js';

let clientsSwiperWr = document.querySelectorAll('.clients-swiper-wr');

clientsSwiperWr.forEach((el) => {
  if (el) {
    let swiperEl = el.querySelector('.swiper');
    let nextEl = el.querySelector('.swiper-button-next');
    let prevEl = el.querySelector('.swiper-button-prev');
    let wrapper = swiperEl.querySelector('.swiper-wrapper');

    let swiper = new Swiper(swiperEl, {
      modules: [Autoplay, Navigation],
      observer: true, //needs to calculate swiper size
      observeParents: true, //needs to calculate swiper size
      spaceBetween: 40,
      slidesPerView: 'auto',
      loop: true,
      breakpoints: {
        640: {
          spaceBetween: 64,
          slidesPerView: 'auto',
        },
        1024: {
          spaceBetween: 100,
          slidesPerView: 'auto',
        },
      },
      navigation: {
        prevEl: prevEl,
        nextEl: nextEl,
      },
      autoplay: {
        delay: 4000,
        disableOnInteraction: false,
        pauseOnMouseEnter: window.innerWidth >= 640,
      },
    });

    swiperObserver(swiper);
  }
});